/**
 * Program: SKP Common Components
 * Author: SKP
 * Description: SKP Common Components
 */
import 'tui-date-picker/dist/tui-date-picker.css';
import Vue              from 'vue';
import DatePicker       from 'tui-date-picker';
import { StringUtil }   from '@/utils';

const MAX_DATE = new Date(2999,12,31),
      MIN_DATE = new Date(1900,1,1);

export default {
    create(contEl, inputEl, openEl, locale = 'en', options = { type: 'date', showToday: false }, value = null) {
        // Vue.$log.info('※ DatePicker.js create =>', contEl, inputEl, openEl, locale, options, value);
        let pickerOptions = {
            input: {
                element: '#' + inputEl,
                format: ( options.type == 'month' ? 'MMM.yyyy' : '' ) || localStorage.getItem('dateFormat') || 'MM.dd.yyyy',
            },
            openers: ['#' + openEl],
            language: locale || localStorage.getItem('language') || 'en',
            calendar: { showToday: options.showToday || false },
            type: ( options.type || 'date' ),
            usageStatistics: false,
        };

        if(value !== null) {
            Object.assign(pickerOptions, { date : value });
        };

        const datePicker = new DatePicker('#' + contEl, pickerOptions);

        datePicker.addCssClass('zindex9999');
        datePicker.on('change', function(){ if(!datePicker.getDate()) datePicker.setNull(); });
        datePicker.on('close', function(){ if(!document.getElementById(inputEl).value.length) datePicker.setNull(); });

        return datePicker;
    },

    /**
     *  DatePicker.createRange(
     *      'from-picker-container', 'fromDate',
     *      'to-picker-container', 'toDate',
     *      { type: 'date', locale: 'en', showToday: false },
     *      (new moment()).add(-1, 'years').toDate(),
     *      (new moment()).toDate()
     *  )
     */
    createRange(sContEl, sIptEl, eContEl, eIptEl, options = { type: 'date', locale: 'en', showToday: false }, sVal = null, eVal = null) {
        // Vue.$log.info('※ DatePicker.js createRange =>', sContEl, sIptEl, eContEl, eIptEl, options, sVal, eVal);
        let pickerOptions = {
            startpicker: {
                date: sVal,
                input: '#' + sIptEl,
                container: '#' + sContEl,
            },
            endpicker: {
                date: eVal,
                input: '#' + eIptEl,
                container: '#' + eContEl,
            },
            calendar: { showToday: options.showToday || false },
            type: ( options.type || 'date' ),
            format: ( options.type == 'month' ? 'MMM.yyyy' : '' ) || localStorage.getItem('dateFormat') || 'MM.dd.yyyy',
            language: options.locale || localStorage.getItem('language') || 'en',
            usageStatistics: false
        };

        const rangePicker = DatePicker.createRangePicker(pickerOptions);

        let startPicker = rangePicker._startpicker,
            endPicker = rangePicker._endpicker;

        startPicker.on('close', function(){ if(!document.getElementById(sIptEl).value.length) startPicker.setNull(); });
        endPicker.on('close',   function(){ if(!document.getElementById(eIptEl).value.length) endPicker.setNull();   });

        return rangePicker;
    },

    /**
     *  DatePicker.createRange(
     *      'from-picker-container', 'fromDate', 'icoFromDate'
     *      'to-picker-container', 'toDate', 'icoToDate',
     *      ------------------- Additional --------------------
     *      { type: 'date', locale: 'en', showToday: false },
     *      (new moment()).add(-1, 'years').toDate(),
     *      (new moment()).toDate()
     *      ---------------------------------------------------
     *  )
     */
    createRangeWithOpener(sContEl, sIptEl, sOpener, eContEl, eIptEl, eOpener, options = { type: 'date', locale: 'en', showToday: false }, sVal = null, eVal = null, rangeMin = null, rangeMax = null) {
        // Vue.$log.info('※ DatePicker.js createRange =>', sContEl, sIptEl, eContEl, eIptEl, options, sVal, eVal);
        let endVal = eVal;
        if(StringUtil.isNull(endVal)) { endVal = new Date(); };

        if (rangeMin == null) {
            rangeMin = MIN_DATE;
        }

        if (rangeMax == null) {
            rangeMax = new Date(endVal.getFullYear(), endVal.getMonth(), (options.type === 'month' ? 1 : endVal.getDate()));
        }

        let pickerOptions = {
            startpicker: {
                date: sVal,
                input: '#' + sIptEl,
                container: '#' + sContEl,
            },
            endpicker: {
                date: endVal,
                input: '#' + eIptEl,
                container: '#' + eContEl,
            },
            /*
             * 20.08.10 - 현업 사용자들의 요구로 인해 날짜 제한 해제
             * selectableRanges: [ [rangeMin, rangeMax] ],
             */
            calendar: { showToday: options.showToday || false },
            type: ( options.type || 'date' ),
            format: ( options.type == 'month' ? 'MMM.yyyy' : '' ) || localStorage.getItem('dateFormat') || 'MM.dd.yyyy',
            language: options.locale || localStorage.getItem('language') || 'en',
            usageStatistics: false
        };

        const rangePicker = DatePicker.createRangePicker(pickerOptions);

        let startPicker = rangePicker._startpicker,
            endPicker = rangePicker._endpicker;

        // Add Opener
        if(sOpener !== null) startPicker.addOpener('#'+sOpener);
        if(eOpener !== null) endPicker.addOpener('#'+eOpener);

        startPicker.on('close', function(){ if(!document.getElementById(sIptEl).value.length) startPicker.setNull(); });
        endPicker.on('close',   function(){ if(!document.getElementById(eIptEl).value.length) endPicker.setNull();   });

        return rangePicker;
    },
};



// WEBPACK FOOTER //
// ./src/skpComponents/common/DatePicker.js